export default (state, action) => {
  switch (action.type) {
    case "LOGIN_BUYER":
      return { ...state, currentUser: { loading: true, error: "" } };

    case "LOGIN_BUYER_SUCCESS":
      return {
        ...state,
        currentUser: {
          loading: false,
          token: action.payload.token,
          user: action.payload.user,
          ioSocket: action.payload.ioSocket,
          error: "",
        },
      };

    case "LOGIN_BUYER_ERROR":
      return {
        ...state,
        currentUser: {
          loading: false,
          token: null,
          user: null,
          ioSocket: null,
          error: action.payload.message,
        },
      };

    case "LOGOUT_BUYER":
      localStorage.removeItem("token");
      return {
        ...state,
        currentUser: {
          loading: false,
          token: null,
          user: null,
          ioSocket: null,
          error: "",
        },
      };
    case "RESET_PASSWORD":
      return { ...state, currentUser: { loading: true }, error: "" };
    case "RESET_PASSWORD_SUCCESS":
      return {
        ...state,
        currentUser: {
          loading: false,
          token: action.payload.token,
          user: action.payload.user,
          ioSocket: action.payload.ioSocket,
          error: "",
        },
      };
    case "RESET_PASSWORD_ERROR":
      return {
        ...state,
        currentUser: {
          loading: false,
          token: null,
          user: null,
          ioSocket: null,
          error: action.payload.message,
        },
      };
    case "GET_INIT_SETTINGS":
      return {
        ...state,
        settings: {
          chargeBalanceFees: action.payload.chargeBalanceFees,
          activeAuctionsTap: action.payload.activeAuctionsTap,
        },
      };
    case "CHANGE_TO_SINGLE_SELLER":
      return {
        ...state,
        singleSeller: action.payload.singleSeller,
      };

    default:
      return { ...state };
  }
};
